/**
 * jQuery.browser.mobile (http://detectmobilebrowser.com/)
 *
 * jQuery.browser.mobile will be true if the browser is a mobile device
 *
 **/
(function(a){(jQuery.browser=jQuery.browser||{}).mobile=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))})(navigator.userAgent||navigator.vendor||window.opera);

if(!jQuery.browser.mobile) {
    $('.mobile').hide();
}

$(window).on('load', function(){ // makes sure the whole site is loaded
    $('#status').fadeOut(); // will first fade out the loading animation
    $('#preloader').delay(0).fadeOut('slow'); // will fade out the white DIV that covers the website.
    $('body').delay(0).css({'overflow': 'visible'});
});

$(document).ready(function () {

    $('.main-nav .dropdown').dropdown();
    
    $('.main-nav .dropdown').hover(function()  {
        if ($(document).width() >= 768) {
            $(this).find('.dropdown-menu').first().stop(true, true).slideDown();
        }}, function()  {
            if ($(document).width() >= 768) {
                $(this).find('.dropdown-menu').first().stop(true, true).slideUp(0);
            }
        });

    $('.main-menu > .dropdown').click(function()  {
        if ($(this).find('ul').length === 0) {
            window.location.href = $(this).children().first().attr("href");
        } else if ($(document).width() < 768) {
            if(!$(this).hasClass("dropdown-open")) {
                $(this).addClass("dropdown-open");
                $(this).find('.dropdown-menu').first().stop(true, true).slideDown();
            } else {
                $(this).removeClass("dropdown-open");
                $(this).find('.dropdown-menu').first().stop(true, true).slideUp();
            }
        }
    });
    
    $('.main-menu .dropdown-menu .dropdown a').click(function()  {
        window.location.href = $(this).attr("href");
    });
    
    $('.contact-form').ajaxForm({
        url: $('.contact-form').attr('action'),
        type: 'post',
        data: $(this).serialize(),
        success: function (data)
        {
            //console.log(data);
            if(data == "OK") {
                $('.contact-form .form-result-loading').hide();
                $('.contact-form .form-result-ok').show();
            } else {
                $('.contact-form .form-result-loading').hide();
                $('.contact-form .form-result-error').show();
            }
        },
        error: function(jqXHR) {
            //console.log(jqXHR.statusText)
            //$('.content-area').html(jqXHR.responseText);
            $('.contact-form .form-result-loading').hide();
            $('.contact-form .form-result-error').show();
        }
    });
    
    if(typeof grecaptcha !== 'undefined') {
        grecaptcha.ready(function() {
            
            var isSamsungBrowser = navigator.userAgent.match(/SamsungBrowser/i);
            if(isSamsungBrowser) {
                $('.grecaptcha-badge').hide();
                //$('footer .container').append("it is samsung");
                //$('.grecaptcha-badge').css("visibility", "hidden");
                //$('.grecaptcha-badge').css("opacity", "0");
            }
                
            // do request for recaptcha token
            // response is promise with passed token
            var captcha_site_key = $('.contact-form').data('captcha_site_key');
            //console.log("captcha_site_key: "+captcha_site_key);
            grecaptcha.execute(captcha_site_key, {action: 'contact'}).then(function(token) {
                //console.log("token: "+token);
                $('.contact-form').prepend('<input type="hidden" name="form[g-recaptcha-response]" value="' + token + '">');
            });
        });
    }
        
    //var location_loaded = false;
    $('.search-main .toggle-btn, .search-widget .search-widget-district').on('click', function() {
        if( $('#search-locations').has('option').length == 0 ) {
        //if(!location_loaded) {
            load_locations();
        }
    });

    $('.layout-grid').on('click', function () {
        $('.layout-grid').addClass('active');
        $('.layout-list').removeClass('active');

        $('#list-type').removeClass('proerty-th-list');
        $('#list-type').addClass('proerty-th');

    });

    $('.layout-list').on('click', function () {
        $('.layout-grid').removeClass('active');
        $('.layout-list').addClass('active');

        $('#list-type').addClass('proerty-th-list');
        $('#list-type').removeClass('proerty-th');

    });

    var RGBChange = function () {
        $('#RGB').css('background', '#FDC600')
    };

    // Advanced search toggle
    var $SearchToggle = $('.search-form .search-toggle');
    $SearchToggle.hide();

    $('.search-form .toggle-btn').on('click', function (e) {
        e.preventDefault();
        $SearchToggle.slideToggle(300);
        if($(this).find("i").hasClass("fa-plus")) {
            $(this).find("i").attr("class","fa fa-minus");
        } else {
            $(this).find("i").attr("class","fa fa-plus");
        }
    });

    function sdf_FTS(_number, _decimal, _separator) {
        var decimal = (typeof (_decimal) != 'undefined') ? _decimal : 2;
        var separator = (typeof (_separator) != 'undefined') ? _separator : '';
        var r = parseFloat(_number)
        var exp10 = Math.pow(10, decimal);
        r = Math.round(r * exp10) / exp10;
        rr = Number(r).toFixed(decimal).toString().split('.');
        b = rr[0].replace(/(\d{1,3}(?=(\d{3})+(?:\.\d|\b)))/g, "\$1" + separator);
        r = (rr[1] ? b + '.' + rr[1] : b);

        return r;
    }
    
$("form button[type=submit]").mousedown(function(e) { 
    if(e.which== 2) {
        e.preventDefault();
        $("form").attr('target', '_blank');
        $("form").submit();
        $("form").removeAttr('target');
    }
});

$("#copyright-year").html(new Date().getFullYear());
    
});

//facebook share
//(function(d, s, id) {
//    var js, fjs = d.getElementsByTagName(s)[0];
//    if (d.getElementById(id)) return;
//    js = d.createElement(s); js.id = id;
//    js.src = "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.0";
//    fjs.parentNode.insertBefore(js, fjs);
//  }(document, 'script', 'facebook-jssdk'));
  
export function addCommas(nStr)
{
    nStr += '';
    var x = nStr.split('.');
    var x1 = x[0];
    var x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + '.' + '$2');
    }
    return x1 + x2;
}

export function load_locations() {
    $.ajax({
        url: $('#search-locations').attr('data-ajax-url'),
        type: 'post',
        success: function (data)
        {
            $('#search-locations').html(data).selectpicker('refresh');
            //location_loaded = true;
        },
        error: function(jqXHR) {
            console.log(jqXHR.statusText)
        }
    });
}
